export default class ProtocolService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/protocols/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/protocols', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/protocols', params);
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/protocols/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/protocols/' + id, params)
	}

	getSimpleEntities(params) {
		return this.apiService.callGet('me/protocols/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/ProtocolService.js